import React from "react";

const FormattedNumberInput = ({ value, onChange, placeholder, className }) => {
  // Display formatted value (with commas) but keep raw numeric in state
  const displayValue =
    value === "" || value === null || isNaN(value)
      ? ""
      : Number(value).toLocaleString();

  return (
    <input
      type="text"
      inputMode="numeric"
      placeholder={placeholder}
      className={className}
      value={displayValue}
      onChange={(e) => {
        const raw = e.target.value.replace(/,/g, "");
        onChange(raw === "" || isNaN(raw) ? "" : Number(raw));
      }}
    />
  );
};

export default FormattedNumberInput;
